import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Col, Row } from 'react-bootstrap';
import moment from 'moment-timezone';
import { toDisplayDateTimeString } from '../../helpers/moment-ex';
import { DataTable, DataTableLoading, DataTableRecordsNotFound } from '../widgets/DataTable';
import { getHardwareActivityList } from '../../actions/hardware';

const HardwareActivityInfo = (props) => {
    const { isRequesting, hardwareActivityDetails, farmIds, hardwareId, actions } = props;

    useEffect(() => {
        if (hardwareId && farmIds.length > 0 && !hardwareActivityDetails) actions.getHardwareActivityList({ hardware_uuid: hardwareId, farm_uuid: farmIds })
    }, [farmIds, hardwareId]);

    return <Row className="m-0">
        <Col className="p-0">
            <DataTable className='tbl-fixed'>
                <DataTable.Header>
                    <DataTable.Row>
                        <DataTable.Cell style={{ width: "40px" }}>#</DataTable.Cell>
                        <DataTable.Cell style={{ width: "150px", textAlign: "center" }}>Farm Name</DataTable.Cell>
                        <DataTable.Cell style={{ width: "200px", textAlign: "center" }}>Equipment Group Name</DataTable.Cell>
                        <DataTable.Cell style={{ width: "200px", textAlign: "center" }}>Date</DataTable.Cell>
                    </DataTable.Row>
                </DataTable.Header>
                <DataTable.Body>
                    {(!isRequesting && hardwareActivityDetails && hardwareActivityDetails.length > 0) && hardwareActivityDetails.map((item, i) =>
                        <DataTable.Row className={`item ${item.is_active && "active"}`} key={i}>
                            <DataTable.Cell style={{ width: "40px", textAlign: "center" }}>{i + 1}</DataTable.Cell>
                            <DataTable.Cell style={{ width: "150px" }}>{item.farm_name}</DataTable.Cell>
                            <DataTable.Cell style={{ width: "200px" }}>{item.equipment_group_name}</DataTable.Cell>
                            <DataTable.Cell style={{ width: "200px" }}>
                                <label className={`display-date-range`}>
                                    <span><i className="fa fa-calendar mr-1" /></span>
                                    {toDisplayDateTimeString(item.start_date, (moment.utc(item.start_date).year() === moment.utc().year()))}
                                    <i className="fa fa-long-arrow-right i-arrow mx-2" aria-hidden="true"></i>
                                    {item.is_alive ? "Now" : toDisplayDateTimeString(item.end_date, (moment.utc(item.end_date).year() === moment.utc().year()))}
                                </label>
                            </DataTable.Cell>
                        </DataTable.Row>)}
                </DataTable.Body>
            </DataTable>
            {isRequesting && <DataTableLoading />}
            {(!isRequesting && hardwareActivityDetails && hardwareActivityDetails.length === 0) && <DataTableRecordsNotFound />}
        </Col>
    </Row>
}

const mapStateToProps = (state, { hardwareId }) => {
    const hardwareActivityInfo = state.hardware.hardwareActivity[`${hardwareId}`]
        ? state.hardware.hardwareActivity[`${hardwareId}`] : null;
    return {
        isRequesting: hardwareActivityInfo ? hardwareActivityInfo.isRequesting : false,
        hardwareActivityDetails: hardwareActivityInfo ? hardwareActivityInfo.payload : null
    };
};

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({ getHardwareActivityList }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(HardwareActivityInfo);